import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import AOS from 'aos'
import 'aos/dist/aos.css'

import Navbar from './components/navbar'
import Footer from './components/footer'

import Home from './pages/home'
import ReachUs from './pages/reach-us'
import About from './pages/about'
import Expertise from './pages/expertise'
import Leadership from './pages/leadership'
import Download from './pages/download'
import Leader from './pages/leadership/leader'
import Projects from './pages/projects'
import Industry from './pages/industry'
import Achievements from './pages/achievements'
import Careers from './pages/careers'
import Jobrole from './pages/careers/jobrole'
import Leaders from './static/js/leaders'

import ScrollToTop from './components/scrolltotop'

AOS.init()

const App = () => {
  return (
    <Router>
      <div className='App'>
        {/* <Navbar /> */}
        <ScrollToTop>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/reach-us' element={<ReachUs />} />
            <Route path='/about-us' element={<About />} />
            <Route path='/about-us/industry' element={<Industry />} />
            <Route path='/expertise' element={<Expertise />} />
            <Route path='/leadership' element={<Leadership />} />
            <Route path='/download' element={<Download />} />
            <Route
              path='/leadership/hitesh-arora'
              element={<Leader data={Leaders[0]} />}
            />
            <Route
              path='/leadership/rishi-arora'
              element={<Leader data={Leaders[1]} />}
            />
            <Route
              path='/leadership/rajesh-kumar-bansal'
              element={<Leader data={Leaders[2]} />}
            />
            <Route path='/projects' element={<Projects />} />
            <Route path='/achievements-and-media' element={<Achievements />} />
            <Route path='/careers' element={<Careers />} />
            <Route path='/careers/:id' element={<Jobrole />} />
          </Routes>
        </ScrollToTop>
        <Footer />
      </div>
    </Router>
  )
}

export default App
